import { useRef, ReactElement } from 'react';
import {
  Container, Row, Col, Button,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useSelector, useDispatch } from 'react-redux';
import { StateRedux } from '../../store/type-redux';
import { alerts } from '../../utils';
import { InputUnform, load } from '../../components';
import validarErroForm from './utils/validar-erro-form-set-pass';

const SetPassword = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { access } = useSelector((state: StateRedux) => state);

  const formRef = useRef<FormHandles>(null);

  const handleLogin = async (data: any) => {
    try {
      formRef.current?.setErrors({});

      await validarErroForm(data);

      load.show();

      dispatch({
        type: 'ACCESS',
        access: {
          ...access,
          resetPassword: true,
        },
      });

      // await api.alterarSenha(data);
      navigate('/home');
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      load.hide();
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xl={6} lg={12} md={9}>
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <Row>
                <Col lg={12}>
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-4">
                        Alteração de senha provisória
                      </h1>
                    </div>
                    <Form ref={formRef} onSubmit={handleLogin}>
                      <div className="form-group">
                        <InputUnform
                          type="password"
                          name="senhaAtual"
                          className="form-control form-control-user"
                          placeholder="Senha atual"
                        />
                      </div>
                      <div className="form-group">
                        <InputUnform
                          type="password"
                          name="novaSenha"
                          className="form-control form-control-user"
                          placeholder="Nova senha"
                        />
                      </div>
                      <div className="form-group">
                        <InputUnform
                          type="password"
                          name="repetirSenha"
                          className="form-control form-control-user"
                          placeholder="Repetir nova senha"
                        />
                      </div>

                      <hr />

                      <Button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                        variant="primary"
                      >
                        Definir nova senha
                      </Button>
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SetPassword;
